import { required, numeric, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    input: {
      actual_quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Quantity must be greater than 0.'), minValue(0.0001))
      }
    }
  }
};
